import * as Constants from '../constants';

const initialState = {
  isLoading: false,
  error: null,
  data: {
    aggregates: {
      totalSubscribers: 0,
      totalEmailSent: 0,
      undersaturationRate: 0,
      oversaturationRate: 0
    },
    frequencies: []
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case Constants.REQUEST_FREQUENCIES:
      return { ...state, isLoading: true };
    case Constants.RECEIVE_FREQUENCIES:
      if (action.error) {
        console.log(`Receive Frequencies Error  ${action.error}`);
        return {
          ...state,
          isLoading: false,
          error: action.error
        };
      }
      return {
        isLoading: false,
        data: action.frequencies,
        error: null
      };
    default:
      return state;
  }
}
